import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

export const RFC3339ZonedDateTimeString = z.codec(
  z.iso.datetime({ offset: true }),
  z.instanceof(Temporal.ZonedDateTime),
  {
    decode: (str) => {
      if (str.includes('[')) {
        return Temporal.ZonedDateTime.from(str);
      }

      return Temporal.Instant.from(str).toZonedDateTimeISO('UTC');
    },
    encode: (zonedDateTime) => zonedDateTime.toInstant().toString(),
  },
);

export const RFC3339InstantString = z.codec(
  z.iso.datetime({ offset: true }),
  z.instanceof(Temporal.Instant),
  {
    decode: (isoString) => Temporal.Instant.from(isoString),
    encode: (instant) => {
      return instant.toString();
    },
  },
);

export const RFC3339PlainDateString = z.codec(
  z.iso.date(),
  z.instanceof(Temporal.PlainDate),
  {
    decode: (isoString) =>
      Temporal.PlainDate.from(isoString, { overflow: 'reject' }),
    encode: (plainDate) => plainDate.toString({ calendarName: 'never' }),
  },
);
